import { customerData } from '../../utilities/CustomerData'

import refundIcon from '../../assets/DashboardIcons/DashboardTopBarIcons/refundIcon.png'
import refundStageIcon from '../../assets/DashboardIcons/DashboardTopBarIcons/stageIcon.png'

export default function DashboardTopBar() {
  return (
    <div className='lg:w-full w-11/12 flex max-sm:flex-col flex-row justify-between gap-5'>
      {customerData.customerLeadData.leadType !== 'Leads' ? (
        <div className='flex-1 flex flex-col relative text-[#74be43]'>
          <div className="relative flex items-center w-full">
            <p className="text-lg font-bold text-center w-full">Calculated Refund</p>
          </div>
          <p className='text-center font-bold text-6xl mt-auto'>
          ${customerData.customerLeadData.leadAmount.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: customerData.customerLeadData.leadAmount % 1 !== 0 ? 2 : 0})}
          </p>
        </div>
      ) : (
        <div className='flex-1 flex flex-col'>
          <div className="relative flex items-center w-full">
            <p className="text-lg font-bold text-center w-full">Estimated Refund</p>
          </div>
          <p className='text-gray-600 text-center font-bold text-6xl'>${customerData.customerLeadData.leadEstimateRefund.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: customerData.customerLeadData.leadAmount % 1 !== 0 ? 2 : 0})}</p>
        </div>
      )}
      {window.innerWidth > 768 && (
        <div className='shadow-full rounded-xl p-4 bg-white flex-1 flex flex-col relative'>
          <div className="flex items-center">
            <p className='text-md font-bold absolute left-1/2 transform -translate-x-1/2'>Refund Stage</p>
          </div>
          <p className='text-gray-600 text-center font-bold text-xl mt-auto'>
            {customerData.customerLeadData.leadType === 'Leads' ? 'Application Incomplete' : customerData.customerStageHistory.find(customerStage => customerStage.currentStage === true).customerStageName}
          </p>
        </div>
      )}
    </div>
  )
}